import React from "react";
import Tilt from 'react-parallax-tilt';
import brain from './face-scan.png';
const Logo=()=>{
    return(
      <Tilt className="parallax-effect ba" style={{width:'100px',height:'100px',marginLeft:'10px', backgroundColor:' #FFDEE9',
      backgroundImage: 'linear-gradient(66deg, #FFDEE9 0%, #B5FFFC 50%, #9fefdb 100%)'}} perspective={600}>
      <div className="inner-element">
        <div><img src={brain} alt='logo'/></div>
      </div>
    </Tilt>
    )
}
export default Logo;